// /frontend/src/pages/admin/finanzas/PuntosCobro.jsx
import React, { useState, useEffect } from 'react';
import { finanzasAPI } from '../../../api/finanzas/finanzas.api';

export default function PuntosCobro() {
  const [puntos, setPuntos] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [nuevoPunto, setNuevoPunto] = useState({ 
    nombre: '', 
    sucursal_id: '',
    tipo: 'CAJA'
  });
  const [editando, setEditando] = useState(null);
  const [editData, setEditData] = useState({ nombre: '', sucursal_id: '', tipo: 'CAJA' });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [puntosRes, sucursalesRes] = await Promise.all([
        finanzasAPI.getPuntosCobro(),
        finanzasAPI.getSucursales()
      ]);
      setPuntos(puntosRes.data);
      setSucursales(sucursalesRes.data);
    } catch (error) {
      console.error("Error cargando datos:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nuevoPunto.nombre || !nuevoPunto.sucursal_id) {
      alert("Debe seleccionar una sucursal y escribir un nombre");
      return;
    }
    try {
      await finanzasAPI.crearPuntoCobro(nuevoPunto);
      setNuevoPunto({ nombre: '', sucursal_id: '', tipo: 'CAJA' });
      cargarDatos();
    } catch (error) {
      console.error("Error creando punto de cobro:", error);
      alert("Error al crear");
    }
  };

  const handleEdit = (punto) => {
    setEditando(punto.id);
    setEditData({
      nombre: punto.nombre,
      sucursal_id: punto.sucursal_id || '',
      tipo: punto.tipo || 'CAJA'
    });
  };

  const handleUpdate = async (id) => {
    try {
      await finanzasAPI.actualizarPuntoCobro(id, editData);
      setEditando(null);
      cargarDatos();
    } catch (error) {
      console.error("Error actualizando:", error);
      alert("Error al actualizar");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este punto de cobro?')) return;
    try {
      await finanzasAPI.eliminarPuntoCobro(id);
      cargarDatos();
    } catch (error) {
      console.error("Error eliminando:", error);
      alert("Error al eliminar");
    }
  };

  const getTipoLabel = (tipo) => {
    switch (tipo) {
      case 'CAJA': return '💰 Caja';
      case 'BANCO': return '🏦 Banco';
      case 'OTRO': return '📌 Otro';
      default: return tipo;
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>📍 Gestión de Puntos de Cobro</h2>

      {/* Formulario de creación */}
      <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '5px' }}>
        <h3>Agregar Nuevo Punto de Cobro</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nombre del punto"
            value={nuevoPunto.nombre}
            onChange={(e) => setNuevoPunto({...nuevoPunto, nombre: e.target.value})}
            style={{ marginRight: '10px', padding: '8px', width: '200px' }}
            required
          />
          <select
            value={nuevoPunto.tipo}
            onChange={(e) => setNuevoPunto({...nuevoPunto, tipo: e.target.value})}
            style={{ marginRight: '10px', padding: '8px' }}
          >
            <option value="CAJA">💰 Caja</option>
            <option value="BANCO">🏦 Banco</option>
            <option value="OTRO">📌 Otro</option>
          </select>
          <select
            value={nuevoPunto.sucursal_id}
            onChange={(e) => setNuevoPunto({...nuevoPunto, sucursal_id: e.target.value})}
            style={{ marginRight: '10px', padding: '8px' }}
            required
          >
            <option value="">Seleccione Sucursal</option>
            {sucursales.map(s => (
              <option key={s.id} value={s.id}>{s.nombre}</option>
            ))}
          </select>
          <button type="submit" style={{ padding: '8px 15px' }}>Crear Punto</button>
        </form>
      </div>

      {/* Listado de puntos existentes */}
      <div>
        <h3>Puntos de Cobro Registrados</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>ID</th>
              <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Nombre</th>
              <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Tipo</th>
              <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Sucursal</th>
              <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {puntos.map(punto => (
              <tr key={punto.id}>
                <td style={{ padding: '8px' }}>{punto.id}</td>
                <td style={{ padding: '8px' }}>
                  {editando === punto.id ? (
                    <input
                      value={editData.nombre}
                      onChange={(e) => setEditData({...editData, nombre: e.target.value})}
                      style={{ padding: '4px' }}
                    />
                  ) : (
                    punto.nombre
                  )}
                </td>
                <td style={{ padding: '8px' }}>
                  {editando === punto.id ? (
                    <select
                      value={editData.tipo}
                      onChange={(e) => setEditData({...editData, tipo: e.target.value})}
                      style={{ padding: '4px' }}
                    >
                      <option value="CAJA">💰 Caja</option>
                      <option value="BANCO">🏦 Banco</option>
                      <option value="OTRO">📌 Otro</option>
                    </select>
                  ) : (
                    getTipoLabel(punto.tipo)
                  )}
                </td>
                <td style={{ padding: '8px' }}>
                  {editando === punto.id ? (
                    <select
                      value={editData.sucursal_id}
                      onChange={(e) => setEditData({...editData, sucursal_id: e.target.value})}
                      style={{ padding: '4px' }}
                    >
                      <option value="">Seleccione Sucursal</option>
                      {sucursales.map(s => (
                        <option key={s.id} value={s.id}>{s.nombre}</option>
                      ))}
                    </select>
                  ) : (
                    punto.sucursal_nombre || punto.sucursal?.nombre || 'No asignada'
                  )}
                </td>
                <td style={{ padding: '8px', textAlign: 'center' }}>
                  {editando === punto.id ? (
                    <>
                      <button onClick={() => handleUpdate(punto.id)} style={{ marginRight: '5px' }}>💾</button>
                      <button onClick={() => setEditando(null)}>❌</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => handleEdit(punto)} style={{ marginRight: '5px' }}>✏️</button>
                      <button onClick={() => handleDelete(punto.id)}>🗑️</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {puntos.length === 0 && (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No hay puntos de cobro registrados</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
